export default {
    title: 'Kết quả buổi học',

    sessionInfo: {
        title: 'Thông tin cơ bản',
        items: {
            date: 'Ngày học',
            duration: 'Thời gian tiến hành',
            studentCount: 'Tham gia',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration} phút)',
    },
    curriculumInfo: {
        title: 'Tên buổi học',
    },

    summary: {
        title: 'Thông tin hoạt động',
        completedActivity: 'Hoạt động đã thực hiện',
        headers: {
            activity: 'Hoạt động',
            achievement: 'Thành tích',
        },
    },

    studentResults: {
        title: 'Số câu đúng và MVP theo từng học sinh',
        mvp: 'MVP',
        headers: {
            student: 'Học sinh',
            answers: 'Số câu đúng',
            score: 'Điểm',
        },
    },

    actions: {
        close: 'Đóng cửa sổ',
        print: 'In',
        export: 'Xuất',
    },

    errors: {
        windowClose: 'Đã xảy ra lỗi. Vui lòng đóng cửa sổ thủ công.',
    },
};
